/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import userDataStore from '../userDataStore';

function confirmUseWebAppAction() {
  return {
    type: 'CONFIRM_USE_WEB_APP',
    useWebApp: true
  };
}

function confirmUseWebApp() {
  return function(dispatch) {
    const confirmUseWebApp = parseInt(userDataStore.get('confirmUseWebApp'), 10);

    userDataStore.put('confirmUseWebApp', isNaN(confirmUseWebApp) ? 1 : confirmUseWebApp + 1);

    return dispatch(confirmUseWebAppAction());
  };
}

export {confirmUseWebApp};